import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { SubSpendingTypeProps, TSubSpendingTypesState } from '../../types'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseSubSpendingTypes } from './utils'
import { selectors } from './selectors'
import { subSpendingTypesAdapter } from './adapter'
import { FetchCollectionParams, FetchCreatedAtParams, UpdateEntityProps } from '../../../services/_common'

const name = 'subSpendingTypes'

const initialState: TSubSpendingTypesState = {
    ...subSpendingTypesAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {

        const order = params?.order || {'order[name]': 'asc'}

        return parseSubSpendingTypes(await moneyFlowService.fetchSubSpendingTypes({
            pagination: params?.pagination,
            page: params?.page,
            perPage: params?.perPage,
            ...order
        }))
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (spendingType: SubSpendingTypeProps) => {
        return await moneyFlowService.createSubSpendingType(spendingType)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (spendingType: UpdateEntityProps<SubSpendingTypeProps>) => {
        return await moneyFlowService.updateSubSpendingType(spendingType)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await moneyFlowService.removeSubSpendingType(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                subSpendingTypesAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const subSpendingTypes = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove,
    },
    reducer: slice.reducer,
    selectors,
}